var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.342675 18.9884C-0.107584 19.4387 -0.120827 20.2069 0.342675 20.6573C0.806177 21.1076 1.57427 21.1076 2.02453 20.6573L10.5 12.1805L18.9755 20.6573C19.4257 21.1076 20.2071 21.1208 20.6573 20.6573C21.1076 20.1937 21.1076 19.4387 20.6573 18.9884L12.1818 10.4983L20.6573 2.02154C21.1076 1.57121 21.1208 0.803 20.6573 0.35267C20.1938 -0.110906 19.4257 -0.110906 18.9755 0.352669L10.5 8.82948L2.02453 0.352666C1.57427 -0.110909 0.792938 -0.124154 0.342679 0.352666C-0.107581 0.816241 -0.107581 1.57121 0.342678 2.02154L8.81815 10.4983L0.342675 18.9884Z",
    fill: "#f9f9f9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoClose);
export default __webpack_public_path__ + "assets/media/video-close.77aba69aea23fa3d23ad2e7bbbb1bf91.svg";
export { ForwardRef as ReactComponent };